import { CardDieCut } from '@apps/card/routes/CardCustomizer/components/CardDieCut';
import type { DraftJson } from '@apps/card/routes/CardCustomizer/DraftJson.types';
import { DEFAULT_BACKGROUND_COLOR, DEFAULT_ENVELOPE_COLOR, NO_REVEAL_ANIMATION } from './constants';

// Kept out of `useIncludedDesignPolicy` so the paper customizer, which can also switch a draft onto
// the free product, does not pull in the digital editor's upsell hooks to reach these.

/** The one silhouette the free product includes. */
export const INCLUDED_SHAPE = CardDieCut.rectangle;

/** The one reveal animation the free product includes: none at all. The envelope opening is premium. */
export const INCLUDED_ANIMATION = NO_REVEAL_ANIMATION;

/**
 * Put the gated fields that have a known free value back to it, for a draft being moved onto the
 * free product without an upgrade to undo.
 *
 * Unlike `useIncludedDesignPolicy`'s `revertToIncludedDesign`, there is no earlier free design to
 * restore here, so the card back, layer positions and text styling are left as they are -- the
 * free version of those is whatever the template shipped, which the customizer does not hold.
 * The quantity is dropped because on the free product any number there caps the recipients.
 */
export const resetToFreeDefaults = (config: DraftJson) => {
  config.customizations.shape = INCLUDED_SHAPE;
  config.digitalCustomizations = {
    ...config.digitalCustomizations,
    backgroundColor: DEFAULT_BACKGROUND_COLOR,
    envelopeColor: DEFAULT_ENVELOPE_COLOR,
    envelopeAnimation: INCLUDED_ANIMATION,
  };
  delete config.digitalCustomizations.quantity;
};
